import { useTheme } from '@itsrever/design-system'
import Sustainable from './assets/sustainable.svg'
import DeliveryPickup from './assets/delivery_pickup.svg'
import Dropoff from './assets/dropoff.svg'
import HomePickup from './assets/homepickup.svg'
import InStore from './assets/instore.svg'
import Search from './assets/search.svg'
import { usePortalTranslate } from '@/hooks'
import { useContext } from 'react'
import { EditedCopiesContext } from '@/ui/components/portal-preview/preview-contexts'
import { findReturnMethodIndex } from '@/ui/components/portal-preview/settings-indexes'

interface ReturnCardProps {
  method: string | undefined
}

const ReturnCard: React.FC<ReturnCardProps> = ({ method }) => {
  const editedCopies = useContext(EditedCopiesContext)
  const { translate } = usePortalTranslate(editedCopies)
  const theme = useTheme()

  const iconSource = () => {
    switch (method) {
      case 'DROP_OFF_POINT':
        return Dropoff
      case 'DELIVERY_PICKUP':
        return DeliveryPickup
      case 'HOME_PICK_UP':
        return HomePickup
      case 'IN_STORE':
        return InStore
    }
  }

  const greenOption = method === 'IN_STORE'

  const showButton = method === 'IN_STORE'

  const methodIndex = findReturnMethodIndex(method ?? '')

  return (
    <div
      id={method}
      className="relative mb-6 flex flex-col content-center items-center rounded-lg border border-solid border-[#ccc] shadow-sm "
    >
      {greenOption ? (
        <>
          <div
            style={{
              background:
                'radial-gradient(circle at 78px 10px, #20904d, #4caf50 100%)'
            }}
            className="absolute left-4 top-[-10px] flex items-center justify-center gap-[0.3rem] rounded-[20px] border border-solid border-[#20904d] px-[0.8rem] py-[0.1rem] text-white"
          >
            <img src={Sustainable} />
            <p className="text-xs">
              <b
                dangerouslySetInnerHTML={{
                  __html: translate('return_card_green_option')
                }}
              />
            </p>
          </div>
          <div className="absolute right-0 top-0 flex h-[25px] justify-center rounded-bl-[70px] rounded-tr border-b border-solid border-[#20904d] bg-[#20904d] py-[0.2rem] pl-3 pr-[0.4rem] text-white">
            <p
              className="whitespace-nowrap text-xs"
              dangerouslySetInnerHTML={{
                __html: translate('return_card_free')
              }}
            />
          </div>
        </>
      ) : null}
      <div className="mb-1 flex items-center">
        <div className="w-full cursor-pointer rounded px-[12px] py-[14px]">
          <div className="w-full">
            <div className="flex items-center gap-2">
              <img className="size-[15px]" src={iconSource()} />
              <p className="text-lg">
                <b
                  dangerouslySetInnerHTML={{
                    __html: translate(`return_card_method${methodIndex}_title`)
                  }}
                />
              </p>
            </div>

            <p
              className="mt-2 font-normal"
              style={{
                color: theme.colors.grey[0]
              }}
              dangerouslySetInnerHTML={{
                __html: translate(
                  `return_card_method${methodIndex}_description`
                )
              }}
            />
          </div>
          {showButton ? (
            <div className="mt-4 flex justify-center">
              <a
                target="_blank"
                className="flex items-center gap-[0.35rem] rounded-[20px] px-2 py-[0.2rem] hover:underline"
                style={{
                  color: greenOption
                    ? 'white'
                    : theme.colors.primary.contrastText,
                  backgroundColor: greenOption
                    ? '#20904d'
                    : theme.colors.primary.main
                }}
              >
                <img src={Search} />
                <p
                  className="text-xs"
                  dangerouslySetInnerHTML={{
                    __html:
                      method === 'IN_STORE'
                        ? translate('return_card_in_store_link')
                        : translate('return_card_dropoff_link')
                  }}
                />
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default ReturnCard
